/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlUpdateCustomisedContactDetailsMutationVariables = Types.Exact<{
  uri: Types.Scalars["ID"]["input"];
  fields: Types.GqlCustomisedContactDetailsInput;
}>;

export type GqlUpdateCustomisedContactDetailsMutation = {
  __typename: "Mutation";
  updateCustomisedContactDetails: {
    __typename: "CustomisedContactDetails";
    uri: string;
    operationId: string;
    teamUri: string;
    name: string;
    roleName: string;
    contactType: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    deleted?: boolean | null;
    fields: Array<{
      __typename: "CustomisedContactDetailsField";
      fieldName: string;
      label: string;
    }>;
  };
};

export const UpdateCustomisedContactDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCustomisedContactDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uri" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fields" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CustomisedContactDetailsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCustomisedContactDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uri" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fields" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fields" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "customisedContactDetailsFields",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "customisedContactDetailsFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomisedContactDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          { kind: "Field", name: { kind: "Name", value: "operationId" } },
          { kind: "Field", name: { kind: "Name", value: "teamUri" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "roleName" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fields" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "fieldName" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlUpdateCustomisedContactDetailsMutation,
  GqlUpdateCustomisedContactDetailsMutationVariables
>;
